import React, { useState, useEffect, useRef }  from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";

//import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';

import { convertNum, setCursorWaiting } from '../../../utils'

export const CollapseLeaseMileage = ({callback, key, setSelectedLeasesMileage, ...props }) => {
    const { t, i18n } = useTranslation(['payments', 'general']);

    const summaryCalculator = window.summaryCalculator;
	const gtmHelper = new GTMHelper();

    const [isCollapsed, setIsCollapsed] =  useState(false);
    const [didInit, setInit] = React.useState(false);
    const collapseRef = useRef();

    const [collapseClosedContent, setCollapseClosedContent] = useState('');
    const [currentMileage, setCurrentAnnuelMileage] = useState(summaryCalculator.AnnualMileage);
    
    const [update, setForceUpdate] =  useState('');

    //content for mileage current drop down select
    const ClosedContent = ()=>{
        let mileage = '';

        switch (parseInt(summaryCalculator.AnnualMileage)) {
            case 2:
                mileage = 20000;
                break;
            case 3:
                mileage = 16000;
                break;
            case 0:
                mileage = 24000;
                break;
            default:
                break;
        }

        return `${t("annual_km")}: ${convertNum(mileage)}`
    }

    //content for mileage dropdown
    function collapseOpenContent() {
        return (
            <ul className="mz-finance-options__financial-element-list annual-mileage-options">
               
                <li className={`mz-finance-options__financial-element ${summaryCalculator.AnnualMileage === 3 ? 'selected' : ''}`}>
                    <span onClick={itemClick}><label htmlFor="annualMileage">{t("annual_km_16000")}</label><input type="hidden" name="annualMileage" value="3" id="ultra_kilometer_lease"/></span> <i className="mz-svg mz-svg-checkmark"></i>
                </li>
               
                <li className={`mz-finance-options__financial-element ${summaryCalculator.AnnualMileage === 2 ? 'selected' : ''}`}>
                    <span onClick={itemClick}><label htmlFor="annualMileage">{t("annual_km_20000")}</label><input type="hidden" name="annualMileage" value="2" id="low_kilometer_lease"/></span> <i className="mz-svg mz-svg-checkmark"></i> 
                </li>
                <li className={`mz-finance-options__financial-element ${summaryCalculator.AnnualMileage === 0 ? 'selected' : ''}`}>
                    <span onClick={itemClick}><label htmlFor="annualMileage">{t("annual_km_24000")}</label><input type="hidden" name="annualMileage" value="0" id="standard_kilometer_lease"/></span> <i className="mz-svg mz-svg-checkmark"></i>
                </li>
            </ul>
        );
    }

    function handleClick(e) {
        setIsCollapsed(!isCollapsed);

        setInit(false);
        
		gtmHelper.setGTM({'action':'Collapse', 'type': 'Lease Mileage', 'value': !isCollapsed}, true , false);
    }

    // update mileage value
    async function itemClick(e) {
        setCursorWaiting(true);

        callback(e);

        //setForceUpdate(Math.random());
        
        setCursorWaiting(false);

        gtmHelper.setGTM({'action':'Checkbox', 'type': 'Lease Mileage', 'value': summaryCalculator.AnnualMileage}, true , false);
    }

    useEffect(() =>{
        (async () => {
            //setInit(false);
            //setIsCollapsed(false);
            const collapse = collapseRef.current;

            if(!isCollapsed)
                collapse.style.height = "0px";
            else {
                collapse.style.height = null;
                window.mzAnimator.animateHeight(collapse, 'CollapseListMileage', true);
            }

            //collapse.style.removeProperty('height');
            
            //setForceUpdate(Math.random());

            setCollapseClosedContent(ClosedContent());
        })();        
    }, [summaryCalculator._tradeInValue, summaryCalculator._downPaymentValue, summaryCalculator.LoyaltyChecked, summaryCalculator.GraduateChecked, summaryCalculator.MilitaryChecked, summaryCalculator.FirstTimeOwnerChecked, summaryCalculator.IncludeFees, summaryCalculator.IncludeTaxes, summaryCalculator.IncludeRebates]);

    useEffect(() =>{
        (async () => {
            const collapse = collapseRef.current;

            /*if(typeof window.mzAnimator === 'object'){
                window.mzAnimator.animateHeight(collapse, 'CollapseListMileage', 'init')
            }*/

            if(typeof window.mzAnimator === 'object' && !didInit){
                window.mzAnimator.animateHeight(collapse, 'CollapseListMileage', 'init')
                setInit(true);
                window.mzAnimator.animateHeight(collapse, 'CollapseListMileage', isCollapsed);
            }
            else {
                //collapse.style.height = "500px";
                window.mzAnimator.animateHeight(collapse, 'CollapseListMileage', isCollapsed);            
            }

        })();
    }, [isCollapsed, didInit]);

    /*useEffect(()=>{
        
    }, [currentMileage, update]);*/

    useEffect(()=>{
        setCurrentAnnuelMileage(summaryCalculator.AnnualMileage);

        setCollapseClosedContent(ClosedContent());
    }, [summaryCalculator.AnnualMileage]);

    return (
        <div className="mz-collapse mz-collapse--finance" key={key}>
            <button
                onClick={handleClick}
                className="mz-collapse__button"
            >
                <div className="mz-collapse__cartext-container">
                    <p className="mz-collapse__text">{collapseClosedContent}</p>
                </div>
                <i className={ !isCollapsed ? "mz-svg mz-svg-chevron_small open  mz-svg--grey" : "mz-svg mz-svg-chevron_small  mz-svg--grey"}></i>
            </button>
            <div className="mz-collapse__box" ref={collapseRef}>{collapseOpenContent()}</div>
        </div>
    )
}

CollapseLeaseMileage.propTypes = {

}

CollapseLeaseMileage.defaultProps = {

}

export default CollapseLeaseMileage;